export default [
  [`Размеры`, `XS-S`, `M-L`, `XL-2XL`],
  [`Российский размер`, `44-46`, `48-50`, `52-54`],
  [`Обхват груди`, `88-92`, `96-100`, `104-108`]
];
